// @ts-nocheck
import styled from 'styled-components'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Title from 'components/common/Title'
import TypographyPro from 'themes/TypographyPro'

export const StyledSubTitleGrid = styled(Grid)`
	&.MuiGrid-item {
		padding: 0 12px 0 12px;
	}
`

export const StyledSubTitle = styled(TypographyPro)`
	line-height: 26px;
	margin: 22px 0;
`

export const StyledDisclaimer = styled(TypographyPro)`
	line-height: 19px;
`

export const StyledTitleGrid = styled(Grid)`
	&.MuiGrid-item {
		padding: 0 12px;
	}
`

export const StyledFormControlLabel = styled(FormControlLabel)`
	margin: 0;
	& .MuiTypography-body1 {
		font-size: 12px;
		font-family: 'Work Sans', OpenSansHebrew;
	}
`

export const StyledContactUsCheckboxesContainer = styled.div`
	padding: 0 2px;
	display: flex;
	flex-direction: column;
	width: 100%;
`

export const StyledTitle = styled(Title)`
	@media (max-width: 576px) {
		margin: 10px 15px 5px 0;
	}
	@media (min-width: 577px) {
		align-self: center;
	}
	text-align: center;
`

export const StyledGridContainer = styled(Grid)`
	margin-bottom: ${({ $isCheckboxContainer }) => $isCheckboxContainer && '18px'};
`

export const StyledFieldsContainer = styled(Grid)`
	margin: 15px 0;
	@media (max-width: 576px) {
		margin: 0;
		// padding: 0 9px;
	}
`

export const StyledGridContainerForTextFields = styled(Grid)`
	&.MuiGrid-item {
		//padding: 12px 12px 20px 12px;
		//@media (max-width: 576px) {
		//	padding: 12px 12px 24px 12px;
		//}
		padding: 14px 12px;
	}
`

export const StyledGridContainerForCheckboxes = styled(Grid)`
	&.MuiGrid-item {
		padding: 8px 12px 18px 8px;
	}
`

export const StyledDivider = styled(Divider)`
	&.MuiDivider-root {
		margin: 5px 15px;
		@media (max-width: 576px) {
			#contact_us_divider {
				display: none;
			}
		}
	}
`

export const StyledError = styled.p`
	font-family: Work Sans, 'Roboto', 'Helvetica', 'Arial', sans-serif;
	font-size: 12px;
	font-weight: 400;
	color: red;
`
